// removed by extract-text-webpack-plugin
module.exports = {"item":"_1y0a7VuLJC8EHNY-PdD41H","popoverContainer":"_3I6BKURpjgDTdIFLCmEPxs","name":"_3byTClOYHO-jJy-s1GuWnr","lockedIcon":"_1D_FHIbDK08yuLmN7Ckpa3","shown":"_29Wqno31fUQPs7RB891SVx","popoverContent":"_2bS8gULUi5P8KnI_cJEqrD","popoverItem":"_2UxEcT5yZv7thXXiPjiP7m","selected":"_3McxbIPtftBIBEnZ9Dq1Pp"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Users/UserPage/Roles/style/RoleItem.pcss
// module id = 1362
// module chunks = 0